
import React from 'react';
import './Playlist.css';

import ButtonIconV2 from '../common/ButtonIconV2';
import IconAdd from '../content/list/svg/IconAdd';
import IconRemove from '../content/list/svg/IconRemove';
import IconMoveTop from './svg/IconMoveTop';
import IconMoveBottom from './svg/IconMoveBottom';

import usePlaylistEdit from './hooks/usePlaylistEdit';

function ButtonsPlaylistEdit() {
  const { removeSelected, addToPlaylist, hasSelectedItems, moveDirection } = usePlaylistEdit();
 
  return (
    <>
      <ButtonIconV2 className={`playlist-button-edit-add ${!hasSelectedItems && 'disable'}`}
        icon={<IconAdd color={'#B3B3B3'} />}
        label={`Add to playlist`}
        onClick={addToPlaylist}
      />
      <ButtonIconV2
        className={`playlist-button-edit-add svg-stroke ${!hasSelectedItems && 'disable'}`}
        icon={<IconMoveTop />}
        label={`Move Top`}
        onClick={moveDirection(true)}
      />
      <ButtonIconV2
        className={`playlist-button-edit-add svg-stroke ${!hasSelectedItems && 'disable'}`}
        icon={<IconMoveBottom />}
        label={`Move Bottom`}
        onClick={moveDirection(false)}
      />
      <ButtonIconV2 className={`playlist-button-edit-add ${!hasSelectedItems && 'disable'}`} 
        icon={<IconRemove color={'#B3B3B3'} />}
        label={`Remove selected`}
        onClick={removeSelected}
      />
    </>
  )
}

export default ButtonsPlaylistEdit;
